import { milliseconds } from '/constants/constants';

/**
 * Converts a time duration to milliseconds.
 *
 * Performs a pure unit conversion using predefined time precisions.
 * No rounding, side effects, or domain-specific logic is applied.
 */
export const toMs = (precision: keyof typeof milliseconds, multiplier: number) => multiplier * milliseconds[precision];
